import {
    API_REQUEST,
    MANAGE_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID,
    RESET_PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID,
    SAVE_RESULT
} from "../../actionTypes/actionsTypes";
import { AppAction, AsyncActionType, LocalAction } from "../../types";

// Manage unit income action
export const getIncomeAttributesBySnapshotId = (snapshotId: number | string, target: AsyncActionType = MANAGE_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/snapshots/${snapshotId}/income-attributes`,
        next: target,
        method: 'GET',
        authorization: true
    }
});

export const putIncomeAttributesBySnapshotId = (
    snapshotId: number | string,
    payload: Record<string, unknown>,
): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/income/snapshots/${snapshotId}/income-attributes`,
        data: { ...payload },
        next: SAVE_RESULT,
        method: 'PUT',
        authorization: true
    }
});

export const resetPutIncomeAttributesBySnapshotId = (): LocalAction => ({
    type: RESET_PUT_INCOME_ATTRIBUTES_BY_SNAPSHOT_ID
});